import React from 'react';
import './autenticazione.scss';
import InsertOtp from '../../component/insert-otp/insert-otp';

function Autenticazione() {
  return (
    <div className="Autenticazione">
      <div className="page-container">
        <h3 className="page-title-success">Autenticazione</h3>
        <InsertOtp/>
      </div>
    </div>
  );
}

export default Autenticazione;
